import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {amazonClick}      from '../services/tracking'
import cns from 'classnames'

export default class BuyPopup extends Component {
    constructor(props, ctx){
        super(props, ctx)

        this.hidePopup = this.hidePopup.bind(this)
        this.clickLink = this.clickLink.bind(this)
        this.clickLocal = this.clickLocal.bind(this)
        this.clickDownloadStore = this.clickDownloadStore.bind(this)
    }
    componentWillMount(){
        document.querySelector('#app').addEventListener('mousedown', this.hidePopup)
    }
    hidePopup(e){
        if (e.target.getAttribute('data-is-buy-item')) return

        e.preventDefault()
        e.stopPropagation()

        this.unbind()
        this.props.hidePopup()
    }
    componentWillUnmount(){
        this.unbind()
    }
    clickLink(e){
        e.preventDefault()
        e.stopPropagation()
        let link = e.target.getAttribute('data-link')
        const type = e.target.dataset.type
        if (!link) {
            console.error('missing link on buy popup')
            return
        }
        if (type === 'nya-store') {
            window.open(link)
            this.props.hidePopup()
            return
        }
        if (type !== 'xstream') {
            window.displayWarningMessage({
                type,
                link
            })
            this.props.hidePopup()
            return
        }
        let isAmazon = e.target.getAttribute('data-is-amazon')
        if (isAmazon) {
            amazonClick(link)
        }
        window.open(link)
    }
    clickDownloadStore(e){
        e.preventDefault()
        e.stopPropagation()
        window.open('https://store.neilyoungarchives.com/')
        this.props.hidePopup()
    }
    clickLocal(e){
        e.preventDefault()
        e.stopPropagation()
        this.unbind()
        this.props.hidePopup()
        if (this.props.history) {
            this.props.history.push('/find-store')
        } else {
            window.location.href = '/find-store'
        }
    }
    isAlbumReleased(releaseDate) {
        if (!releaseDate || !releaseDate.month || !releaseDate.year) return false
        const release = new Date(releaseDate.year, releaseDate.month - 1, 1)
        const now = new Date()
        return release < now
    }
    unbind(){
        document.querySelector('#app').removeEventListener('mousedown', this.hidePopup)
    }
    render(){
        const { buyLinks, freeTrack, isTrack, buttonLink, playlistBackground, releaseDate } = this.props
        // Track menus inside playlists pass their own items ("Add to playlist",
        // "Remove from this playlist"), shown above the regular buy links.
        const links = Array.isArray(buyLinks) ? buyLinks : []
        const customItems = links.filter(item => item.isCustomItem)
        // Direct high-res link for the track's album, when one exists
        const hiResLink = links.find(item => item.type === 'xstream')
        const showDownloadStore = !!hiResLink || this.isAlbumReleased(releaseDate)
        let idx = 0
        return (
            <div className={cns("buy-button-popup", {
              'buy-button-popup--track': isTrack,
              'buy-button-popup--bigBackground': freeTrack,
              'buy-button-popup--playlistBackground': playlistBackground,
              'buy-button-popup--compact': customItems.length > 0
            })} style={this.props.style}>
              <div className="links">
                {customItems.map(({title, customItemClick}) => (
                    <div
                        key={`custom-${idx}`}
                        data-is-buy-item="1"
                        onClick={customItemClick}
                        className={`item-${idx++}`}
                    >{title}</div>
                ))}
                <div
                    data-link="https://neilyoung.warnerrecords.com/"
                    data-is-buy-item="1"
                    data-type="nya-store"
                    onClick={this.clickLink}
                    className={`item-${idx++}`}
                >BUY FROM NYA STORE</div>
                {showDownloadStore && (
                    <div
                        data-link={hiResLink ? hiResLink.link : "https://store.neilyoungarchives.com/"}
                        data-is-buy-item="1"
                        data-type={hiResLink ? "xstream" : "nya-download-store"}
                        onClick={hiResLink ? this.clickLink : this.clickDownloadStore}
                        className={`item-${idx++}`}
                    >BUY FROM NYA DOWNLOAD STORE</div>
                )}
                <div
                    data-link="/find-store"
                    data-is-buy-item="1"
                    data-type="local"
                    onClick={this.clickLocal}
                    className={`item-${idx++}`}
                >BUY LOCAL</div>
              {buttonLink && <label
                data-is-buy-item="1"
                className="button"
                onClick={this.clickLink}
                data-link={buttonLink.link}
                data-type={buttonLink.type}
              >FREE DOWNLOAD</label>}
              </div>
            </div>
        )
    }
}

BuyPopup.contextTypes = {
    router: PropTypes.object.isRequired
}
